import Vue from 'vue'
import VueRouter from 'vue-router'
import multiguard from "vue-router-multiguard";
import Login from '../views/auth/Login.vue'
// import Signup from '../views/auth/Signup.vue'
// import UserSettings from '../views/user/UserSettings.vue'
// import BoxSettings from '../views/user/BoxSettings.vue'
// import EventLogs from '../views/user/EventLogs.vue'

// // dealer pages
// import DealerLogin from '../views/dealer/DealerLogin.vue'
// import DealerHome from '../views/dealer/DealerHome.vue'
// import DealerInfo from "../views/dealer/DealerInfo.vue"
// import EmployeesList from "../views/dealer/EmployeesList.vue"

// admin pages
import AdminHome from "../views/admin/AdminHome.vue"
import Dealers from "../views/Dealers.vue"
// import AdminDevices from "../views/admin/AdminDevices.vue"

import { checkLoggedinUser, checkLoggedinDealer, storeDataInSessionStorage, storeDataInSessionStorageFromLocalStorage } from "../common/HelperFunctions";

Vue.use(VueRouter)

// Route guard for all pages to check existing user
const authGuard = function (to, from, next) {
  if(checkLoggedinUser()){
    next();
  } else {
    next("/login")
  }
};

const authScreens = function (to, from, next) {

  let searchParams = window.location.search;
  if(searchParams.includes('token') && searchParams.includes('authLevel')){
    let param1 = searchParams.split("?token=");
    let param2 = param1[1].split("&authLevel=");
    
    if(param2.length && param2[0] && param2[1]){
      storeDataInSessionStorage(param2[0], param2[1])
      if(param2[1] === "1"){
        next("/")
      } else {
        next("/admin-home");
      }
    }
  } else if(sessionStorage.userToken){
    if(sessionStorage.authLevel === "1"){
      next("/");
    } else if(sessionStorage.authLevel === "3" || sessionStorage.authLevel === "0"){
      next("/admin-home");
    } else {
      next();
    }
  } else if(localStorage.userToken){
    if(localStorage.authLevel === "1"){
      next("/");
    } else if(localStorage.authLevel === "3" || localStorage.authLevel === "0"){
      next("/admin-home");
    } else {
      next();
    }
    storeDataInSessionStorageFromLocalStorage();
  } else {
    next()
  }
};

const dealerAuthGuard = function (to, from, next) {
  if(localStorage.userToken && localStorage.authLevel === "0"){
    next();
  } else {
    next("/dealer-login")
  }
};

const adminAuthGuard = function (to, from, next) {
  if(checkLoggedinDealer()){
    next();
  } else {
    next("/login")
  }
};


const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    // beforeEnter: multiguard([authScreens])
  },
  {
    path: '/:centerLoc?',
    name: 'AdminHome',
    component: AdminHome,
    beforeEnter: multiguard([authGuard])
  },
  {
    path: '/view/dealers/:centerLoc?/:lang?/:solar?',
    name: 'Dealers',
    component: Dealers,
  }
  // {
  //   path: '/signup',
  //   name: 'Signup',
  //   component: Signup,
  //   beforeEnter: multiguard([authScreens])
  // },
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home,
  //   // beforeEnter: multiguard([authGuard])
  // },
  // {
  //   path: '/user-settings',
  //   name: 'UserSettings',
  //   component: UserSettings,
  //   beforeEnter: multiguard([authGuard])
  // },
  // {
  //   path: '/box-settings',
  //   name: 'BoxSettings',
  //   component: BoxSettings,
  //   beforeEnter: multiguard([authGuard])
  // },
  // {
  //   path: '/event-logs',
  //   name: 'EventLogs',
  //   component: EventLogs,
  //   beforeEnter: multiguard([authGuard])
  // },
  // {
  //   path: '/dealer-login',
  //   name: 'DealerLogin',
  //   component: DealerLogin,
  //   // beforeEnter: multiguard([authScreens])
  // },
  // {
  //   path: '/dealer-home',
  //   name: 'DealerHome',
  //   component: DealerHome,
  //   beforeEnter: multiguard([dealerAuthGuard])
  // },
  // {
  //   path: '/dealer-info',
  //   name: 'DealerInfo',
  //   component: DealerInfo,
  //   beforeEnter: multiguard([dealerAuthGuard])
  // },
  // {
  //   path: '/employees',
  //   name: 'EmployeesList',
  //   component: EmployeesList,
  //   beforeEnter: multiguard([dealerAuthGuard])
  // },
  // {
  //   path: '/admin-home',
  //   name: 'AdminHome',
  //   component: AdminHome,
  //   beforeEnter: multiguard([adminAuthGuard])
  // },
  // {
  //   path: '/admin-devices',
  //   name: 'AdminDevices',
  //   component: AdminDevices,
  //   beforeEnter: multiguard([adminAuthGuard])
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
